import {
  LAMBDATEST_BUILD_DATA_MINIMAL_LOADING,
  LAMBDATEST_BUILD_DATA_MINIMAL_SUCCESS,
  LAMBDATEST_BUILD_DATA_MINIMAL_FAILED,
  LAMBDATEST_BUILD_DATA_MINIMAL_CLEAR,
  LAMBDATEST_BROWSER_LIST_LOADING,
  LAMBDATEST_BROWSER_LIST_SUCCESS,
  LAMBDATEST_BROWSER_LIST_FAILED,
  LAMBDATEST_BROWSER_LIST_CLEAR,
  LAMBDATEST_OS_LIST_LOADING,
  LAMBDATEST_OS_LIST_SUCCESS,
  LAMBDATEST_OS_LIST_FAILED,
  LAMBDATEST_OS_LIST_CLEAR,
  LAMBDATEST_USER_LIST_LOADING,
  LAMBDATEST_USER_LIST_SUCCESS,
  LAMBDATEST_USER_LIST_FAILED,
  LAMBDATEST_USER_LIST_CLEAR,
  LAMBDATEST_GROUP_LIST_LOADING,
  LAMBDATEST_GROUP_LIST_SUCCESS,
  LAMBDATEST_GROUP_LIST_FAILED,
  LAMBDATEST_BUILD_DATA_MINIMAL_SILENT_LOADING,
  LAMBDATEST_BUILD_EXISTENCE_MINIMAL_LOADING,
  LAMBDATEST_BUILD_EXISTENCE_MINIMAL_SUCCESS,
  LAMBDATEST_BUILD_EXISTENCE_MINIMAL_FAILED,
  LAMBDATEST_TAG_LIST_SILENT_LOADING,
  LAMBDATEST_TAG_LIST_LOADING,
  LAMBDATEST_TAG_LIST_SUCCESS,
  LAMBDATEST_TAG_LIST_FAILED,
  LAMBDATEST_BUILD_TAG_LIST_LOADING,
  LAMBDATEST_BUILD_TAG_LIST_SUCCESS,
  LAMBDATEST_BUILD_TAG_LIST_FAILED,
  LAMBDATEST_BUILD_TAG_LIST_SILENT_LOADING,
  LAMBDATEST_BUILD_PROJECT_LIST_LOADING,
  LAMBDATEST_BUILD_PROJECT_LIST_SILENT_LOADING,
  LAMBDATEST_BUILD_PROJECT_LIST_SUCCESS,
  LAMBDATEST_BUILD_PROJECT_LIST_FAILED,
  LAMBDATEST_TAG_DETAILS_LOADING,
  LAMBDATEST_TAG_DETAILS_SUCCESS,
  LAMBDATEST_TAG_DETAILS_FAILED,
} from '../actionTypeConstants/LambdaTestConfigDataConstants';

import get from 'lodash/get';

const initialState = {
  buildList: {
    loading: false,
    data: null,
    error: null,
    silentLoading: false,
  },
  userBuildList: {
    loading: false,
    data: null,
    error: null,
    silentLoading: false,
  },
  osList: {
    loading: false,
    data: null,
    error: null,
  },
  browserList: {
    loading: false,
    data: null,
    error: null,
  },
  userList: {
    loading: false,
    data: null,
    error: null,
  },
  groupList: {
    loading: false,
    data: null,
    error: null,
  },
  tagList: {
    loading: false,
    data: null,
    error: null,
    silentLoading: false,
    searchText: '',
  },
  buildTagList: {
    loading: false,
    data: null,
    error: null,
    silentLoading: false,
  },
  projectList: {
    loading: false,
    data: null,
    error: null,
    silentLoading: false,
  },
  defaultTagDetails: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_BUILD_DATA_MINIMAL_LOADING:
      return {
        ...state,
        buildList: { ...state.buildList, loading: true, silentLoading: false },
      };

    case LAMBDATEST_BUILD_DATA_MINIMAL_SILENT_LOADING:
      return {
        ...state,
        buildList: { ...state.buildList, loading: false, silentLoading: true },
      };

    case LAMBDATEST_BUILD_DATA_MINIMAL_SUCCESS:
      return {
        ...state,
        buildList: {
          ...state.buildList,
          loading: false,
          data: action.result.data,
        },
      };

    case LAMBDATEST_BUILD_DATA_MINIMAL_FAILED:
      return {
        ...state,
        buildList: {
          ...state.buildList,
          loading: false,
          error: action.error,
        },
      };

    case LAMBDATEST_BUILD_DATA_MINIMAL_CLEAR:
      return {
        ...state,
        buildList: initialState.buildList,
      };
    case LAMBDATEST_BUILD_EXISTENCE_MINIMAL_LOADING:
      return {
        ...state,
        userBuildList: {
          ...state.userBuildList,
          loading: true,
          silentLoading: false,
        },
        buildList: {
          ...state.buildList,
          loading: true,
          silentLoading: false,
        },
      };

    case LAMBDATEST_BUILD_EXISTENCE_MINIMAL_SUCCESS:
      return {
        ...state,
        userBuildList: {
          ...state.userBuildList,
          loading: false,
          data: action.result.data,
        },
        buildList: {
          ...state.buildList,
          loading: false,
          data: action.result.data,
        },
      };

    case LAMBDATEST_BUILD_EXISTENCE_MINIMAL_FAILED:
      return {
        ...state,
        userBuildList: {
          ...state.userBuildList,
          loading: false,
          error: action.error,
        },
        buildList: {
          ...state.buildList,
          loading: false,
          error: action.error,
        },
      };

    case LAMBDATEST_OS_LIST_LOADING:
      return {
        ...state,
        osList: {
          ...state.osList,
          loading: true,
        },
      };

    case LAMBDATEST_OS_LIST_SUCCESS:
      return {
        ...state,
        osList: {
          ...state.osList,
          loading: false,
          data: action.result.data,
        },
      };

    case LAMBDATEST_OS_LIST_FAILED:
      return {
        ...state,
        osList: {
          ...state.osList,
          loading: false,
          error: action.error,
        },
      };

    case LAMBDATEST_OS_LIST_CLEAR:
      return {
        ...state,
        osList: initialState.osList,
      };

    case LAMBDATEST_BROWSER_LIST_LOADING:
      return {
        ...state,
        browserList: {
          ...state.browserList,
          loading: true,
        },
      };

    case LAMBDATEST_BROWSER_LIST_SUCCESS:
      return {
        ...state,
        browserList: {
          ...state.browserList,
          loading: false,
          data: action.result.data,
        },
      };

    case LAMBDATEST_BROWSER_LIST_FAILED:
      return {
        ...state,
        browserList: {
          ...state.browserList,
          loading: false,
          error: action.error,
        },
      };

    case LAMBDATEST_BROWSER_LIST_CLEAR:
      return {
        ...state,
        browserList: initialState.browserList,
      };

    case LAMBDATEST_USER_LIST_LOADING:
      return {
        ...state,
        userList: {
          ...state.userList,
          loading: true,
        },
      };

    case LAMBDATEST_USER_LIST_SUCCESS:
      return {
        ...state,
        userList: {
          ...state.userList,
          loading: false,
          data: action.result.data,
        },
      };

    case LAMBDATEST_USER_LIST_FAILED:
      return {
        ...state,
        userList: {
          ...state.userList,
          loading: false,
          error: action.error,
        },
      };

    case LAMBDATEST_USER_LIST_CLEAR:
      return {
        ...state,
        userList: initialState.userList,
      };

    case LAMBDATEST_GROUP_LIST_LOADING:
      return {
        ...state,
        groupList: {
          ...state.groupList,
          loading: true,
        },
      };

    case LAMBDATEST_GROUP_LIST_SUCCESS:
      return {
        ...state,
        groupList: {
          ...state.groupList,
          loading: false,
          data: action.result.data,
        },
      };

    case LAMBDATEST_GROUP_LIST_FAILED:
      return {
        ...state,
        groupList: {
          ...state.groupList,
          loading: false,
          error: action.error,
        },
      };

    case 'LAMBDATEST_BUILD_DATA_MINIMAL_UPDATE':
      let buildData = state.buildList.data || [];
      let foundIndex = buildData.findIndex(
        (build) => build.id == action.payload.id
      );
      if (foundIndex !== -1) {
        buildData[foundIndex].name = action.payload.name;
      }
      return {
        ...state,
        buildList: {
          ...state.buildList,
          loading: false,
          data: buildData,
        },
      };
    case LAMBDATEST_TAG_LIST_LOADING:
      return {
        ...state,
        tagList: { ...state.tagList, loading: true, silentLoading: false },
      };

    case LAMBDATEST_TAG_LIST_SILENT_LOADING:
      return {
        ...state,
        tagList: { ...state.tagList, loading: false, silentLoading: true },
      };

    case LAMBDATEST_TAG_LIST_SUCCESS: {
      const { data } = action.result;

      const searchText = get(action, ['payload', 'tagName'], false);

      const prevSearch = state.tagList.searchText;
      const isNewSearch = searchText !== prevSearch;

      return {
        ...state,
        tagList: {
          ...state.tagList,
          loading: false,
          searchText: searchText,
          data: isNewSearch ? data : { ...state.tagList.data, ...data },
        },
      };
    }

    case LAMBDATEST_TAG_LIST_FAILED:
      return {
        ...state,
        tagList: {
          ...state.tagList,
          loading: false,
          error: action.error,
        },
      };
    case LAMBDATEST_BUILD_TAG_LIST_LOADING:
      return {
        ...state,
        buildTagList: {
          ...state.buildTagList,
          loading: true,
          silentLoading: false,
        },
      };

    case LAMBDATEST_BUILD_TAG_LIST_SILENT_LOADING:
      return {
        ...state,
        buildTagList: {
          ...state.buildTagList,
          loading: false,
          silentLoading: true,
        },
      };

    case LAMBDATEST_BUILD_TAG_LIST_SUCCESS: {
      const { data } = action.result;

      const searchText = get(action, ['payload', 'tagName'], false);

      const prevSearch = state.buildTagList.searchText;
      const isNewSearch = searchText !== prevSearch;

      return {
        ...state,
        buildTagList: {
          ...state.buildTagList,
          loading: false,
          searchText: searchText,
          data: isNewSearch ? data : { ...state.buildTagList.data, ...data },
        },
      };
    }

    case LAMBDATEST_BUILD_TAG_LIST_FAILED:
      return {
        ...state,
        buildTagList: {
          ...state.buildTagList,
          loading: false,
          error: action.error,
        },
      };
    case LAMBDATEST_BUILD_PROJECT_LIST_LOADING:
      return {
        ...state,
        projectList: {
          ...state.project,
          loading: true,
          silentLoading: false,
        },
      };

    case LAMBDATEST_BUILD_PROJECT_LIST_SILENT_LOADING:
      return {
        ...state,
        projectList: {
          ...state.project,
          loading: false,
          silentLoading: true,
        },
      };

    case LAMBDATEST_BUILD_PROJECT_LIST_SUCCESS:
      return {
        ...state,
        projectList: {
          ...state.project,
          loading: false,
          data: action.result.data,
        },
      };

    case LAMBDATEST_BUILD_PROJECT_LIST_FAILED:
      return {
        ...state,
        projectList: {
          ...state.project,
          loading: false,
          error: action.error,
        },
      };

    case LAMBDATEST_TAG_DETAILS_LOADING:
      return {
        ...state,
        defaultTagDetails: { loading: true },
      };

    case LAMBDATEST_TAG_DETAILS_SUCCESS:
      return {
        ...state,
        defaultTagDetails: {
          ...action.result.data,
          loading: false,
        },
      };

    case LAMBDATEST_TAG_DETAILS_FAILED:
      return {
        ...state,
        defaultTagDetails: {
          loading: false,
        },
      };

    default:
      return state;
  }
}
